import { ApolloCache, useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { GET_ORG_ROLES, GET_POSITION_DETAIL, GET_ROLE_DETAIL } from "../../../../graphql/position-gql";
import useScope from "../../../../hook/useScope";
import { notifySuccess } from "../../../../services/notification";
import { IPosition } from "../../../../types/position";
import { fullNameAutoFormat } from "../../../../utils/format-fullname";
import confirm from "../../../common/confirm";
import DateFormat from "../../../common/date-format";
import { DeleteIcon } from "../../../common/icons";
import { Action, IIndividual } from "../../../../types/individual";
import Info from "../../../common/info";
import SpinnerOverlay from "../../../common/spinner/spinner";
import { ASSIGN_INDIVIDUAL } from "../../../../graphql/individual-gql";
import { GET_ORG_DETAILS } from "../../../../graphql/org-gql";
import { IOrgResponse } from "../../../../types/org";
import Button from "../../../common/button";

type AssignedIndividualProps = {

    role: IPosition;
}

const AssignedIndividual = (props: AssignedIndividualProps)=>{
    const {role} = props
    const [indi,SetIndi] = useState<IIndividual>()
    const [ endAssignment,{loading} ] = useMutation(ASSIGN_INDIVIDUAL);
    const isScope = useScope(role?.orgId,false);
    const [getOrgDetail, { data: orgDetail }] = useLazyQuery<IOrgResponse>(GET_ORG_DETAILS)
    useEffect(()=>{
        //console.log("role:",role)
        SetIndi(role?.individuals?role.individuals[0]:undefined)
        getOrgDetail({ variables: { id: role?.orgId },onCompleted:(data)=>{
            //console.log("orgDetailData:",data)
        } })
    },[role])

    const onEndAssignmentHandle = () =>{
        endAssignmentConfirm().then(()=>{
            endAssignmentExecute()
          })
    }

    const endAssignmentConfirm = () => {
        return confirm({
          title: 'Warning!',
          content: `Are you sure you want to end <b>${fullNameAutoFormat(indi?.firstName,indi?.middleName,indi?.lastName)}'</b> role (${indi?.assignmentType}) assignment from <b>${role.fullPositionName}</b>?`,
          okText: <><DeleteIcon/> End Assignment</>,
          okBtnColor: 'danger'
        })
    }

    const endAssignmentExecute = ()=>{
        endAssignment({
            variables: {
                positionId: role?.positionId||0,
                action: Action.REMOVAL,
                input:{assignmentId: indi?.positionAssignmentId}
            },
          refetchQueries: getRefetchQuery(),
          awaitRefetchQueries: true,
          onCompleted: (data:any) => {
            data && notifySuccess()
          },
          update(cache){
            updateAfterEndAssignemt(cache);
          }
        })

    }

    const updateAfterEndAssignemt = (cache:ApolloCache<any>) => {
            const cachedOrg = cache.readQuery<{
                org:{
                    roles:Array<IPosition>
                }
            }>({
                query: GET_ORG_ROLES,
                variables: { orgId: role?.orgId},
              });

            if(cachedOrg){

                let updatedRoles = [...cachedOrg.org.roles];
                const updatedRoleIndex = updatedRoles.findIndex(
                    (pos: IPosition) => pos.positionId === role.positionId
                  );

                if (updatedRoleIndex !== -1) {
                    const indiIndex = updatedRoles[updatedRoleIndex].individuals.findIndex(
                      (individual:IIndividual) => individual.individualId === indi?.individualId
                    )
                    if(indiIndex!==-1){
                      let updatedIndividuals = [...updatedRoles[updatedRoleIndex].individuals]
                      updatedIndividuals.splice(indiIndex, 1);
                      updatedRoles[updatedRoleIndex]={
                        ...updatedRoles[updatedRoleIndex],
                        individuals: updatedIndividuals
                      };
                    }
                }
                // Update the cached data with the modified roles array
                cache.writeQuery({
                    query: GET_ORG_ROLES,
                    variables: { orgId: role?.orgId },
                    data: {
                        org: {
                            ...cachedOrg.org,
                            roles: updatedRoles,
                        },
                    },
                });

                SetIndi(undefined);

            }

    }

    const getRefetchQuery = () => {
        let queries: any = [];
        queries = [...queries,{query: GET_ROLE_DETAIL, variables: { roleId: role.positionId}}]
        return queries;
    }


    return (
        <div role="region" aria-label="assigned Individual" >
            {loading&&<SpinnerOverlay/>}
            {(!indi)&&
                <Info>There is no one currently assigned to this role.</Info>
            }
            {(indi)&&<>
                <Button color="danger" style={{ marginRight: '15px' }} onClick={onEndAssignmentHandle} disabled={!isScope}>
                    <DeleteIcon /> End Assignment
                </Button>
                <br/><br/>
                <div className='row'>
                    <div className="col-md-6 flex-container" >
                        <div className="flex-item">
                            <div style={{fontWeight:"bold"}}>Individual Name:</div>
                            <div style={{fontWeight:"bold"}}>Related Organization:</div>
                        </div>
                        <div className="flex-item" style={{flexGrow:'1'}}>
                            <div >{fullNameAutoFormat(indi?.firstName,indi?.middleName,indi?.lastName)}</div>
                            <div >{orgDetail?.org.orgName}</div>
                        </div>
                    </div>
                    <div className="col-md-6 flex-container">
                        <div className="flex-item">
                            <div style={{fontWeight:"bold"}}>Start Date:</div>
                            <div style={{fontWeight:"bold"}}>Assignment Type:</div>
                        </div>
                        <div className="flex-item" style={{flexGrow:'1'}}>
                            <div><DateFormat date={indi?.startDate} defaultText="No Date" /></div>
                            <div>{indi?.relType?.label}</div>
                        </div>
                    </div>
                </div>
            </>}
        </div>
    )

}

export default AssignedIndividual;
